"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3 = void 0;
const tslib_1 = require("tslib");
const runtime_1 = require("../runtime");
class S3 {
    upload(name, data, tokens, options) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const { status } = yield runtime_1.SDKRuntime.http.request({
                method: 'PUT',
                url: tokens.upload_url,
                header: Object.assign({ 'Content-Type': tokens.mime_type, 'Cache-Control': 'public, max-age=31536000' }, options === null || options === void 0 ? void 0 : options.header),
                body: data,
            }, options);
            if (status >= 400) {
                throw new Error('Failed to upload');
            }
        });
    }
}
exports.S3 = S3;
